import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Converts a `#RRGGBB` hex color to a comma-separated `"r,g,b"` channel string
 * for use inside `rgba(...)` (e.g. `rgba(${hexToRgb('#181512')}, 0.5)`).
 */
export function hexToRgb(hex: string): string {
  const n = parseInt(hex.replace('#', ''), 16)
  return `${(n >> 16) & 255},${(n >> 8) & 255},${n & 255}`
}

/**
 * A path's last segment ends in a file extension (`/llms.txt`, `/a.woff2`).
 * The extension must start with a letter so version-like slugs (`/legal-v2.1`,
 * `/ent-v2.0-release`) still count as routes. Still a heuristic: a slug ending
 * `.v2` reads as a file and is left bare, which costs a 301, not a broken link.
 */
export const FILE_PATH = /\.[a-z][a-z0-9]*$/i

/**
 * Gives a site-relative path the trailing slash the host redirects to
 * (`/contact?x=1` → `/contact/?x=1`), so a link doesn't cost crawlers a 301.
 * Absolute and protocol-relative URLs, and paths to files (`/x.pdf`), are
 * returned unchanged.
 */
export function withTrailingSlash(href: string): string {
  if (!href.startsWith('/') || href.startsWith('//')) return href
  const i = href.search(/[?#]/)
  const path = i === -1 ? href : href.slice(0, i)
  if (path.endsWith('/') || FILE_PATH.test(path)) return href
  return `${path}/${i === -1 ? '' : href.slice(i)}`
}
